import renderFunction from '../ton/index.js';
import ja from '../../app/ton/messages/ja-ton.json';

renderFunction({ ja });
